var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5374 11.8277C13.5374 15.5984 10.5069 18.6552 6.76884 18.6552C3.03073 18.6552 0 15.5977 0 11.8277C0 8.05767 3.0305 5 6.76884 5C10.5072 5 13.5374 8.05698 13.5374 11.8277Z",
    fill: "#8E97CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9627 11.8281C20.9627 15.3775 19.4474 18.2559 17.5783 18.2559C15.7091 18.2559 14.1938 15.3775 14.1938 11.8281C14.1938 8.27883 15.7089 5.40039 17.578 5.40039C19.4472 5.40039 20.9625 8.2779 20.9625 11.8281",
    fill: "#8E97CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.8276C24 15.0069 23.4672 17.5858 22.8097 17.5858C22.1522 17.5858 21.6196 15.0076 21.6196 11.8276C21.6196 8.64758 22.1525 6.06934 22.8097 6.06934C23.467 6.06934 24 8.64735 24 11.8276Z",
    fill: "#8E97CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/mediumIcon.90e3a5b7114ec27b4ea062bbbf45653c.svg";
export { ForwardRef as ReactComponent };